import { ReactElement } from 'react';
import { NavLink } from '@localstack/ui';
import { buildRoute } from '@localstack/services';

import { StepFunctionsRoutes } from '../../types';

interface Props {
  stateMachineArn: string;
  routes: StepFunctionsRoutes;
}

export const MachineNavTabs = ({ stateMachineArn, routes }: Props): ReactElement => (
  <>
    <NavLink to={buildRoute(routes.RESOURCES_STEPFUNCTIONS_STATE_MACHINE_EXECUTIONS, { stateMachineArn })} end>
      Executions
    </NavLink>
    <NavLink to={buildRoute(routes.RESOURCES_STEPFUNCTIONS_STATE_MACHINE_DEFINITION_SCHEMA, { stateMachineArn })}>
      Definition
    </NavLink>
  </>
);
